export default "__VITE_ASSET__Dtn4AjUQ__"